import { ValueComponent } from "components/components/Component";
import {
    OutputBaseDefinition,
    OutputBaseComponent,
    StyleCSSOuput,
    StyleClassCSSOuput
} from "components/output/baseOutputDefinition";
import { OrginalValue } from "components/output/baseHTMLElementOutput";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import { FocusManager } from "components/pages/focusManager";
import i18n from "components/i18n/i18n";
import isEqual from "lodash/isEqual";
import template from "./multiText.hbs";
import "./multiText.scss";

export class MultiTextOutput extends OutputBaseComponent<MultiTextOutputDefinition> implements ValueComponent {

    public readonly componentType: string = "multiTextOutput";

    private _initialValue: OrginalValue = new OrginalValue();
    private _input: MultiTextOutputInputHTML[];

    constructor(schema: MultiTextOutputDefinition) {
        super(schema);
    }

    public render(): Element {
        this.renderTemplate();
        this._input = this.getInputHTMLElements();
        this.bindEvents();
        return this.view;
    }

    public renderTemplate(): Element {
        return super.renderTemplate(template);
    }

    private getInputHTMLElements(): MultiTextOutputInputHTML[] {
        var arr = new Array<MultiTextOutputInputHTML>();
        const inputHTML: HTMLInputElement[] = Array.from(this.view.querySelectorAll("input"));
        var definitionInput = this.definition.inputs.filter((a) => a.label == null);
        for (var i = 0; i < inputHTML.length; i++) {
            arr.push({
                input: inputHTML[i] as HTMLInputElement,
                definition: definitionInput[i] as MultiTextOutputInput
            });
        }
        return arr;
    }

    private bindEvents(): void {

        this._input.forEach(multiTextOutputInputHTML => {
            multiTextOutputInputHTML.input.addEventListener("change", () => {
                const data = this.getValue();
                const isEqual = this.isEqualToInitialValue(data);
                if (!isEqual) {
                    this.initialValue.reassignvalue(data);
                    fireDataChangedEvent(this, this.view, this.getValue());
                }
            });

            if (multiTextOutputInputHTML.definition.tabOnEnter === true) {
                multiTextOutputInputHTML.input.addEventListener("keydown", (e) => {
                    if (e.key === "Enter") {
                        e.stopPropagation();
                        e.preventDefault();
                        FocusManager.focusNext();
                    }
                });
            }
        });
    }

    private isEqualToInitialValue(data: any): boolean {
        let isequal: boolean = true;
        const initialValue = this.initialValue.value;

        isequal = isEqual(this.getValue(), initialValue);

        return isequal;
    }

    public getValue(): any {
        var obj = {};
        this._input.forEach(multiTextOutputInputHTML => {
            obj[multiTextOutputInputHTML.definition.id] = multiTextOutputInputHTML.input.value;
        });
        return obj;
    }

    public value(v: any) {
        this.assignValuesToHTMLInputElement(v);
        this._initialValue.value = this.getValue();
    }

    private assignValuesToHTMLInputElement(v: any) {
        if (v == null || typeof v !== "object") {
            this._input.forEach(multiTextOutputInputHTML => {
                multiTextOutputInputHTML.input.value = null;
            });
        } else if (typeof v === "object") {
            this._input.forEach(multiTextOutputInputHTML => {
                let text;
                if (multiTextOutputInputHTML.definition.translate) {
                    text = i18n.t(v[multiTextOutputInputHTML.definition.id]);
                } else {
                    text = v[multiTextOutputInputHTML.definition.id];
                }
                multiTextOutputInputHTML.input.value = text;
            });
        }
    }

    public get initialValue() {
        return this._initialValue;
    }
}

export interface MultiTextOutputDefinition extends OutputBaseDefinition {
    inputs: MultiTextOutputInput[];
}

interface MultiTextOutputInput {
    id?: string;
    grow?: number;
    styleMaxWidth_ch?: number;
    label?: string;
    numericCode?: boolean;
    translate?: boolean;
    tabOnEnter?: boolean;
    disableFocusKeyboard?: boolean;
    styleCSS?: StyleCSSOuput;
    styleClassCSS?: StyleClassCSSOuput;
}

interface MultiTextOutputInputHTML {
    input: HTMLInputElement,
    definition: MultiTextOutputInput
}
